import { useState } from "react";

import { Button } from "@icg360/design-system";

import { PaperlessModal } from "components/paperless-modal";
import { type CommonPolicyDataQuery } from "gql/__generated__/hooks";

type EnrollPaperlessProps = {
  userDetails: CommonPolicyDataQuery["userDetails"];
  userBilling: CommonPolicyDataQuery["userBilling"];
  isEnrolledDocuments: boolean;
  isEnrolledBilling: boolean;
  policyId: string;
};

const EnrollPaperless = ({
  isEnrolledDocuments,
  isEnrolledBilling,
  userDetails,
  userBilling,
  policyId,
}: EnrollPaperlessProps) => {
  const [showPaperlessModal, setShowPaperlessModal] = useState(false);

  const { insuredPreferences } = userDetails ?? {};

  return (
    <>
      {(!isEnrolledDocuments || !isEnrolledBilling) && (
        <Button
          appearance="secondary"
          leadingIcon="Paperless"
          onPress={() => setShowPaperlessModal(true)}
          data-testid="enroll-paperless-btn"
        >
          Enroll in paperless
        </Button>
      )}
      {(!isEnrolledBilling || !isEnrolledDocuments) && (
        <PaperlessModal
          show={showPaperlessModal}
          onClose={() => setShowPaperlessModal(false)}
          documentsEmailAddress={
            insuredPreferences?.opInsuredEmailAddressDocuments ||
            insuredPreferences?.opInsuredEmailAddress
          }
          userDetails={userDetails}
          userBilling={userBilling}
          policyId={policyId}
        />
      )}
    </>
  );
};

export default EnrollPaperless;
